import {RolePermissionType} from '../backend/enums/role-permission-type';
import {useAuth} from '../contexts/auth/context';

/**
 * The assignments of the attendance tracker are for users that can read them, and only while the attendance
 * tracker is enabled in the entity (in the settings of the entity).
 */
export const useCanViewAttendanceTrackerAssignments = (): boolean => {
  const {state, hasReadPermission} = useAuth();

  return (
    hasReadPermission(RolePermissionType.Team_AttendanceTracker_Assignments) &&
    state.session?.selectedAffiliation?.attendanceTracker?.isEnabled === true
  );
};
